import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'crowdfunding-settings2',
    templateUrl: './crowdfunding-settings2.component.html',
    styleUrls: ['./crowdfunding-settings2.component.scss'],
    standalone: false
})
export class CrowdfundingSettings2Component
  extends EaSubscriptionBuilder
  implements OnInit
{
  supportType: string;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.supportType =
      pledge?.products?.[0]?.parameters
        ?.crowdfundingNominatifAdministredOption == 'COMPTE_TITRE'
        ? 'Compte Titre'
        : 'PEA PME';
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
